import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import CompanyHeader from './components/CompanyHeader';
import CompanyOverview from './components/CompanyOverview';
import OpenPositions from './components/OpenPositions';
import EmployeeReviews from './components/EmployeeReviews';
import CompanyCulture from './components/CompanyCulture';
import BenefitsPerks from './components/BenefitsPerks';
import LeadershipTeam from './components/LeadershipTeam';
import CompanyContact from './components/CompanyContact';
import CompanyNews from './components/CompanyNews';

const CompanyProfile = () => {
  const [isFollowing, setIsFollowing] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const companyData = {
    name: "TechVision Solutions India Pvt Ltd",
    tagline: "Building Tomorrow\'s Technology Today",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1576cf26e-1764221711681.png",
    logoAlt: "TechVision Solutions modern blue and white geometric logo with abstract tech symbol",
    coverImage: "https://images.unsplash.com/photo-1637621982007-44aaf9f9b0c6",
    coverImageAlt: "Modern open-plan office space with glass walls, collaborative workstations, natural lighting, and employees working on computers in contemporary workspace",
    industry: "Information Technology & Services",
    employeeCount: "5,000-10,000 employees",
    location: "Bangalore, Karnataka",
    foundedYear: 2010,
    description: `TechVision Solutions India Pvt Ltd is a leading technology services and consulting company headquartered in Bangalore, India. With over a decade of excellence, we specialize in digital transformation, cloud computing, artificial intelligence, and enterprise software solutions.\n\nOur team of 7,500+ professionals across 15 offices in India serves clients globally, delivering innovative solutions that drive business growth and operational efficiency. We pride ourselves on fostering a culture of innovation, continuous learning, and employee empowerment.\n\nAs a Great Place to Work certified company for five consecutive years, we offer exceptional career growth opportunities, competitive compensation, and a work environment that values diversity, inclusion, and work-life balance.`,
    mission: "To empower businesses worldwide with cutting-edge technology solutions that transform operations, enhance customer experiences, and drive sustainable growth through innovation and excellence.",
    vision: "To be the most trusted technology partner globally, recognized for our innovation, quality of service, and positive impact on businesses, communities, and the environment.",
    values: [
    {
      icon: "Lightbulb",
      title: "Innovation",
      description: "Continuously pushing boundaries to create breakthrough solutions"
    },
    {
      icon: "Users",
      title: "Collaboration",
      description: "Working together to achieve extraordinary results"
    },
    {
      icon: "Award",
      title: "Excellence",
      description: "Delivering superior quality in everything we do"
    },
    {
      icon: "Shield",
      title: "Integrity",
      description: "Maintaining highest ethical standards in all interactions"
    },
    {
      icon: "TrendingUp",
      title: "Growth",
      description: "Fostering continuous learning and development"
    },
    {
      icon: "Heart",
      title: "Care",
      description: "Prioritizing wellbeing of employees and communities"
    }],

    achievements: [
    {
      title: "Great Place to Work Certified 2024",
      year: "2024"
    },
    {
      title: "Top 10 IT Companies in India - Business Today",
      year: "2023"
    },
    {
      title: "Best Employer Brand Award - LinkedIn Talent Awards",
      year: "2023"
    },
    {
      title: "ISO 27001:2013 Certified for Information Security",
      year: "2022"
    }]

  };

  const jobsData = [
  {
    id: 1,
    title: "Senior Full Stack Developer",
    location: "Bangalore, Karnataka",
    experience: "5-8 years",
    salary: "₹18,00,000 - ₹28,00,000 per annum",
    type: "Full-time",
    featured: true,
    skills: ["React", "Node.js", "MongoDB", "AWS"],
    postedDate: "2 days ago",
    applicants: 45
  },
  {
    id: 2,
    title: "DevOps Engineer",
    location: "Hyderabad, Telangana",
    experience: "3-6 years",
    salary: "₹12,00,000 - ₹20,00,000 per annum",
    type: "Full-time",
    featured: true,
    skills: ["Docker", "Kubernetes", "Jenkins", "AWS"],
    postedDate: "5 days ago",
    applicants: 67
  },
  {
    id: 3,
    title: "UI/UX Designer",
    location: "Pune, Maharashtra",
    experience: "2-5 years",
    salary: "₹8,00,000 - ₹15,00,000 per annum",
    type: "Full-time",
    featured: false,
    skills: ["Figma", "Adobe XD", "Prototyping", "User Research"],
    postedDate: "1 week ago",
    applicants: 89
  },
  {
    id: 4,
    title: "Data Scientist",
    location: "Bangalore, Karnataka",
    experience: "4-7 years",
    salary: "₹15,00,000 - ₹25,00,000 per annum",
    type: "Full-time",
    featured: true,
    skills: ["Python", "Machine Learning", "TensorFlow", "SQL"],
    postedDate: "3 days ago",
    applicants: 52
  },
  {
    id: 5,
    title: "Product Manager",
    location: "Mumbai, Maharashtra",
    experience: "6-10 years",
    salary: "₹25,00,000 - ₹40,00,000 per annum",
    type: "Full-time",
    featured: false,
    skills: ["Product Strategy", "Agile", "Stakeholder Management", "Analytics"],
    postedDate: "4 days ago",
    applicants: 34
  },
  {
    id: 6,
    title: "Cloud Architect",
    location: "Bangalore, Karnataka",
    experience: "8-12 years",
    salary: "₹30,00,000 - ₹50,00,000 per annum",
    type: "Full-time",
    featured: true,
    skills: ["AWS", "Azure", "Cloud Security", "Microservices"],
    postedDate: "1 week ago",
    applicants: 28
  },
  {
    id: 7,
    title: "Business Analyst",
    location: "Chennai, Tamil Nadu",
    experience: "3-6 years",
    salary: "₹10,00,000 - ₹18,00,000 per annum",
    type: "Full-time",
    featured: false,
    skills: ["Requirements Analysis", "SQL", "Tableau", "Process Modeling"],
    postedDate: "6 days ago",
    applicants: 71
  },
  {
    id: 8,
    title: "Frontend Developer",
    location: "Remote",
    experience: "2-4 years",
    salary: "₹8,00,000 - ₹14,00,000 per annum",
    type: "Remote",
    featured: false,
    skills: ["React", "TypeScript", "CSS", "Redux"],
    postedDate: "2 days ago",
    applicants: 103
  }];


  const reviewsData = [
  {
    id: 1,
    rating: 5,
    title: "Excellent work culture and growth opportunities",
    role: "Senior Software Engineer",
    department: "Engineering",
    employmentStatus: "Current Employee",
    date: "15/11/2024",
    verified: true,
    pros: "TechVision offers an amazing work environment with supportive management and excellent learning opportunities. The company genuinely cares about employee growth and provides regular training programs. Work-life balance is maintained well with flexible working hours.",
    cons: "Sometimes project deadlines can be tight, but management is understanding and provides necessary support. Office cafeteria could have more variety in food options.",
    helpful: 24
  },
  {
    id: 2,
    rating: 4,
    title: "Great place for career growth",
    role: "Product Manager",
    department: "Product",
    employmentStatus: "Current Employee",
    date: "08/11/2024",
    verified: true,
    pros: "Strong focus on innovation and employee development. The leadership team is approachable and values employee feedback. Competitive salary and comprehensive benefits package including health insurance for family.",
    cons: "Fast-paced environment can be challenging for some. More clarity needed in cross-team communication at times.",
    helpful: 18
  },
  {
    id: 3,
    rating: 5,
    title: "Best decision of my career",
    role: "UI/UX Designer",
    department: "Design",
    employmentStatus: "Current Employee",
    date: "02/11/2024",
    verified: true,
    pros: "Creative freedom to explore new design approaches. Regular design thinking workshops and access to latest design tools. Team collaboration is excellent with designers, developers, and product managers working closely together.",
    cons: "Initial onboarding process could be more structured. Sometimes design iterations take longer due to multiple stakeholder reviews.",
    helpful: 31
  },
  {
    id: 4,
    rating: 4,
    title: "Solid company with good benefits",
    role: "DevOps Engineer",
    department: "Engineering",
    employmentStatus: "Former Employee",
    date: "25/10/2024",
    verified: true,
    pros: "Excellent technical infrastructure and modern tech stack. Good salary increments and performance bonuses. Company provides certification support and conference attendance opportunities.",
    cons: "Some legacy systems still need modernization. On-call rotation can be demanding during critical releases.",
    helpful: 15
  },
  {
    id: 5,
    rating: 5,
    title: "Highly recommend for freshers",
    role: "Junior Developer",
    department: "Engineering",
    employmentStatus: "Current Employee",
    date: "18/10/2024",
    verified: true,
    pros: "Excellent mentorship program for new graduates. Structured training and clear career progression path. Friendly team members always willing to help. Regular team outings and cultural events.",
    cons: "Learning curve can be steep initially. More hands-on projects would be beneficial in the first few months.",
    helpful: 42
  }];


  const overallRating = {
    average: 4.6,
    total: 1247,
    breakdown: [
    { stars: 5, percentage: 68 },
    { stars: 4, percentage: 22 },
    { stars: 3, percentage: 7 },
    { stars: 2, percentage: 2 },
    { stars: 1, percentage: 1 }]

  };

  const galleryData = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1633114072460-c7dd0b7c6161",
    imageAlt: "Modern office workspace with employees collaborating around large desk with laptops and monitors in bright naturally lit environment",
    caption: "Collaborative Workspace"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1542744095-fcf48d80b0fd",
    imageAlt: "Team meeting with diverse group of professionals discussing project around conference table with presentation screen",
    caption: "Team Brainstorming Session"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1603430416701-dbc7b96272cc",
    imageAlt: "Modern office cafeteria with comfortable seating, natural wood furniture, and employees having casual conversations",
    caption: "Office Cafeteria"
  },
  {
    id: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d42285cc-1764221720304.png",
    imageAlt: "Recreational game room with foosball table, bean bags, and employees taking break in colorful casual space",
    caption: "Recreation Area"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1584596421996-e636fb130750",
    imageAlt: "Company annual celebration event with employees gathered in decorated hall with stage and lighting",
    caption: "Annual Day Celebration"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1637743408246-ac98bc90d68b",
    imageAlt: "Professional training session with instructor presenting to engaged audience in modern conference room",
    caption: "Training Workshop"
  },
  {
    id: 7,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1785cea25-1764221719790.png",
    imageAlt: "Team building outdoor activity with employees participating in group exercise in park setting",
    caption: "Team Outing"
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1578991624414-276ef23a534f",
    imageAlt: "Modern office lobby with reception desk, comfortable seating area, and company branding on walls",
    caption: "Office Reception"
  }];


  const testimonialsData = [
  {
    id: 1,
    name: "Priya Sharma",
    role: "Senior Software Engineer",
    tenure: "3 years at TechVision",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_101904fc7-1763294024485.png",
    avatarAlt: "Professional headshot of Indian woman with long black hair wearing blue blazer smiling confidently",
    quote: "TechVision has been instrumental in my career growth. The learning opportunities are endless, and the supportive team environment makes every day enjoyable. I've worked on cutting-edge projects that have significantly enhanced my technical skills."
  },
  {
    id: 2,
    name: "Rahul Verma",
    role: "Product Manager",
    tenure: "4 years at TechVision",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1866265bd-1763293085876.png",
    avatarAlt: "Professional headshot of Indian man with short black hair wearing grey suit and glasses",
    quote: "The company truly values innovation and employee input. I've had the opportunity to lead major product initiatives and work with talented cross-functional teams. The work-life balance and benefits are exceptional."
  },
  {
    id: 3,
    name: "Anjali Patel",
    role: "UX Designer",
    tenure: "2 years at TechVision",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1d71d6fc6-1763295655575.png",
    avatarAlt: "Professional headshot of Indian woman with shoulder-length black hair wearing white shirt smiling warmly",
    quote: "As a designer, I appreciate the creative freedom and collaborative culture at TechVision. The design team is passionate, and we're encouraged to experiment with new approaches. It's a great place to grow as a designer."
  },
  {
    id: 4,
    name: "Vikram Singh",
    role: "DevOps Lead",
    tenure: "5 years at TechVision",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1cf987635-1763295184563.png",
    avatarAlt: "Professional headshot of Indian man with short black hair and beard wearing dark blue shirt",
    quote: "TechVision invests heavily in modern infrastructure and tools. The technical challenges are exciting, and the team is always ready to support each other. The company's commitment to employee development is evident in the numerous training opportunities."
  }];


  const benefitsData = {
    "Health & Wellness": [
    {
      title: "Comprehensive Health Insurance",
      description: "Medical coverage for employee and family including parents"
    },
    {
      title: "Mental Health Support",
      description: "Free counseling sessions and wellness programs"
    },
    {
      title: "Annual Health Checkup",
      description: "Complete health screening for all employees"
    }],

    "Financial": [
    {
      title: "Competitive Salary",
      description: "Industry-leading compensation packages"
    },
    {
      title: "Performance Bonuses",
      description: "Quarterly and annual performance incentives"
    },
    {
      title: "Employee Stock Options",
      description: "ESOP program for eligible employees"
    },
    {
      title: "Provident Fund",
      description: "Enhanced PF contribution beyond statutory requirements"
    }],

    "Work-Life Balance": [
    {
      title: "Flexible Working Hours",
      description: "Choose your work schedule within core hours"
    },
    {
      title: "Work From Home",
      description: "Hybrid work model with remote options"
    },
    {
      title: "Generous Leave Policy",
      description: "30 days annual leave plus public holidays"
    },
    {
      title: "Maternity & Paternity Leave",
      description: "Extended leave for new parents"
    }],

    "Professional Development": [
    {
      title: "Learning Budget",
      description: "Annual budget for courses and certifications"
    },
    {
      title: "Conference Attendance",
      description: "Sponsorship for industry conferences"
    },
    {
      title: "Internal Training",
      description: "Regular workshops and skill development programs"
    },
    {
      title: "Career Mentorship",
      description: "One-on-one mentoring with senior leaders"
    }],

    "Office Perks": [
    {
      title: "Free Meals",
      description: "Complimentary breakfast and lunch"
    },
    {
      title: "Recreation Facilities",
      description: "Game rooms, gym, and relaxation areas"
    },
    {
      title: "Transportation",
      description: "Company cab facility for employees"
    }],

    "Additional Benefits": [
    {
      title: "Team Outings",
      description: "Quarterly team building activities"
    },
    {
      title: "Festival Bonuses",
      description: "Special bonuses during major festivals"
    },
    {
      title: "Referral Bonuses",
      description: "Rewards for successful employee referrals"
    }]

  };

  const leadersData = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "Chief Executive Officer",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_124ed0d25-1763296291208.png",
    imageAlt: "Professional portrait of Indian male CEO in navy blue suit with grey hair and confident expression in modern office",
    bio: "Rajesh brings over 25 years of technology leadership experience. Under his guidance, TechVision has grown into one of India's leading IT services companies with a strong focus on innovation and customer success.",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com"
  },
  {
    id: 2,
    name: "Meera Reddy",
    position: "Chief Technology Officer",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17ab42583-1763300506869.png",
    imageAlt: "Professional portrait of Indian female CTO wearing black blazer with shoulder-length hair and warm smile",
    bio: "Meera is a technology visionary with expertise in cloud computing and AI. She leads TechVision's technology strategy and drives innovation across all product lines, ensuring we stay ahead of industry trends.",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com"
  },
  {
    id: 3,
    name: "Amit Desai",
    position: "Chief Financial Officer",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12c9c0844-1763301703870.png",
    imageAlt: "Professional portrait of Indian male CFO in grey suit with glasses and professional demeanor",
    bio: "Amit has over 20 years of financial management experience in the technology sector. He oversees TechVision's financial operations and strategic planning, ensuring sustainable growth and profitability.",
    linkedin: "https://linkedin.com",
    twitter: null
  },
  {
    id: 4,
    name: "Kavita Nair",
    position: "Chief Human Resources Officer",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1aebf1524-1763300564021.png",
    imageAlt: "Professional portrait of Indian female CHRO wearing white shirt with long black hair and friendly expression",
    bio: "Kavita is passionate about building great workplace cultures. She leads TechVision's people strategy, focusing on talent development, diversity & inclusion, and employee wellbeing.",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com"
  },
  {
    id: 5,
    name: "Sanjay Malhotra",
    position: "Chief Operating Officer",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_146db267c-1763296357676.png",
    imageAlt: "Professional portrait of Indian male COO in dark blue suit with short grey hair and serious expression",
    bio: "Sanjay brings extensive operational excellence experience. He oversees TechVision's global delivery operations, ensuring quality service delivery and operational efficiency across all client engagements.",
    linkedin: "https://linkedin.com",
    twitter: null
  },
  {
    id: 6,
    name: "Deepa Iyer",
    position: "Chief Marketing Officer",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1080cd3cc-1763296113306.png",
    imageAlt: "Professional portrait of Indian female CMO wearing red blazer with medium-length black hair and confident smile",
    bio: "Deepa is a marketing strategist with a proven track record in brand building. She leads TechVision's marketing initiatives, focusing on digital transformation and customer engagement strategies.",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com"
  }];


  const contactData = {
    offices: [
    {
      name: "Headquarters - Bangalore",
      address: "TechVision Tower, Electronic City Phase 1, Bangalore, Karnataka 560100",
      phone: "+91 80 4567 8900"
    },
    {
      name: "Hyderabad Office",
      address: "Plot No. 45, HITEC City, Madhapur, Hyderabad, Telangana 500081",
      phone: "+91 40 4567 8900"
    },
    {
      name: "Pune Office",
      address: "Magarpatta City, Hadapsar, Pune, Maharashtra 411028",
      phone: "+91 20 4567 8900"
    },
    {
      name: "Mumbai Office",
      address: "Bandra Kurla Complex, Bandra East, Mumbai, Maharashtra 400051",
      phone: "+91 22 4567 8900"
    }],

    hrEmail: "careers@techvision.in",
    hrPhone: "+91 80 4567 8901",
    headquarters: {
      name: "TechVision Solutions Headquarters",
      address: "TechVision Tower, Electronic City Phase 1, Bangalore, Karnataka 560100",
      lat: 12.8456,
      lng: 77.6603
    },
    social: [
    { name: "LinkedIn", icon: "Linkedin", url: "https://linkedin.com/company/techvision" },
    { name: "Twitter", icon: "Twitter", url: "https://twitter.com/techvision" },
    { name: "Facebook", icon: "Facebook", url: "https://facebook.com/techvision" },
    { name: "Instagram", icon: "Instagram", url: "https://instagram.com/techvision" },
    { name: "YouTube", icon: "Youtube", url: "https://youtube.com/techvision" }]

  };

  const newsData = [
  {
    id: 1,
    category: "Award",
    title: "TechVision Named 'Great Place to Work' for Fifth Consecutive Year",
    description: "TechVision Solutions has been certified as a Great Place to Work for 2024, marking the fifth consecutive year of this prestigious recognition. The certification is based on extensive employee feedback highlighting the company's exceptional workplace culture.",
    date: "20/11/2024",
    image: "https://images.unsplash.com/photo-1576267423048-15c0040fec78",
    imageAlt: "Business team celebrating achievement with trophy in modern office conference room with applause and smiles"
  },
  {
    id: 2,
    category: "Expansion",
    title: "TechVision Opens New Development Center in Chennai",
    description: "The company announced the opening of its newest development center in Chennai, creating 1,000 new job opportunities. The state-of-the-art facility will focus on AI and machine learning projects for global clients.",
    date: "12/11/2024",
    image: "https://images.unsplash.com/photo-1635071247661-ede154087b09",
    imageAlt: "Modern glass office building exterior with TechVision branding and contemporary architecture in urban setting"
  },
  {
    id: 3,
    category: "Product",
    title: "Launch of CloudVision Platform for Enterprise Digital Transformation",
    description: "TechVision unveiled CloudVision, a comprehensive cloud platform designed to accelerate digital transformation for enterprises. The platform integrates AI, analytics, and automation capabilities.",
    date: "05/11/2024",
    image: "https://images.unsplash.com/photo-1648046757585-e26cba9219e6",
    imageAlt: "Product launch presentation with large screen displaying CloudVision platform interface and audience in modern auditorium"
  },
  {
    id: 4,
    category: "Partnership",
    title: "Strategic Partnership with Leading Global Cloud Provider",
    description: "TechVision announced a strategic partnership to deliver advanced cloud solutions to enterprise clients across India and Southeast Asia, expanding its service portfolio significantly.",
    date: "28/10/2024",
    image: "https://images.unsplash.com/photo-1709353342294-b8f2136e93eb",
    imageAlt: "Business executives shaking hands at partnership signing ceremony with company logos displayed on backdrop"
  }];


  const handleFollowCompany = () => {
    setIsFollowing(!isFollowing);
  };

  return (
    <>
      <Helmet>
        <title>{companyData?.name} - Company Profile | JobPortal India</title>
        <meta name="description" content={`Explore career opportunities at ${companyData?.name}. Learn about company culture, benefits, open positions, and employee reviews.`} />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          <CompanyHeader
            company={companyData}
            onFollowCompany={handleFollowCompany}
            isFollowing={isFollowing} />


          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
            <CompanyOverview company={companyData} />
            
            <OpenPositions jobs={jobsData} />
            
            <EmployeeReviews
              reviews={reviewsData}
              overallRating={overallRating} />

            
            <CompanyCulture
              gallery={galleryData}
              testimonials={testimonialsData} />

            
            <BenefitsPerks benefits={benefitsData} />
            
            <LeadershipTeam leaders={leadersData} />
            
            <CompanyNews news={newsData} />
            
            <CompanyContact contact={contactData} />
          </div>
        </main>

        <footer className="bg-card border-t border-border mt-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="text-center text-sm text-muted-foreground">
              <p>&copy; {new Date()?.getFullYear()} JobPortal India. All rights reserved.</p>
            </div>
          </div>
        </footer>
      </div>
    </>);

};

export default CompanyProfile;